// import Avatar from "@mui/material/Avatar";
// import Stack from "@mui/material/Stack";
import React from "react";
import Card from "@mui/material/Card";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import { IconButton, SvgIcon } from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { Link } from "react-router-dom";
// import { Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
function Logger() {
  return (
    <SvgIcon>
      <svg
        width="18"
        height="22"
        viewBox="0 0 18 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 21H2C1.73478 21 1.48043 20.8946 1.29289 20.7071C1.10536 20.5196 1 20.2652 1 20V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H16C16.2652 1 16.5196 1.10536 16.7071 1.29289C16.8946 1.48043 17 1.73478 17 2V11"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.75 21V14.5"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 16.25L13.25 15.5L14.75 14L16.25 15.5L17 16.25"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 7H13"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M5 11H9"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </SvgIcon>
  );
}

function Apidoc() {
  return (
    <SvgIcon>
      <svg
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.1475 0C2.76307 0.00244721 1.37935 0.0630562 0 0.181667V20C0.999476 19.7798 2.00518 19.5889 3.01583 19.4275C3.1575 19.4042 3.29917 19.3833 3.44 19.3625C3.61917 19.335 3.79833 19.3075 3.97667 19.2825L4.1475 19.2575V0ZM5.13083 0.0025V19.1333C8.54189 18.7273 11.9853 18.6678 15.4083 18.9558V1.2375C12.0336 0.476378 8.58982 0.0625565 5.13083 0.0025ZM6.55333 1.51083C6.5575 1.51078 6.56167 1.51078 6.56583 1.51083C9.11583 1.58417 11.67 1.8475 14.205 2.3025C14.2686 2.31395 14.3293 2.33782 14.3837 2.37276C14.4381 2.40769 14.485 2.45301 14.5218 2.5061C14.5587 2.55919 14.5847 2.61903 14.5984 2.68219C14.6121 2.74534 14.6132 2.81058 14.6017 2.87417C14.5813 2.98578 14.523 3.08692 14.4365 3.16043C14.3501 3.23394 14.2409 3.2753 14.1275 3.2775C14.0951 3.27819 14.0627 3.27568 14.0308 3.27C11.5558 2.82525 9.05111 2.56592 6.5375 2.49417C6.47293 2.49233 6.40934 2.47779 6.35039 2.45137C6.29144 2.42495 6.23827 2.38718 6.19393 2.3402C6.14958 2.29323 6.11493 2.23797 6.09195 2.17759C6.06897 2.11722 6.05811 2.05291 6.06 1.98833C6.06391 1.86026 6.11766 1.73878 6.2098 1.64975C6.30195 1.56072 6.42521 1.51117 6.55333 1.51167V1.51083ZM3.04333 1.53417C3.16846 1.5366 3.28796 1.58666 3.37746 1.67415C3.46695 1.76163 3.51972 1.87996 3.525 2.005C3.53042 2.13515 3.48397 2.26213 3.39585 2.35806C3.30773 2.454 3.18514 2.51104 3.055 2.51667C2.40011 2.54374 1.74581 2.58375 1.0925 2.63667C1.08141 2.6376 1.07029 2.63815 1.05917 2.63833C0.934695 2.6398 0.814301 2.594 0.722277 2.51017C0.630254 2.42635 0.573452 2.31073 0.563333 2.18667C0.552966 2.05685 0.594526 1.92822 0.678892 1.82902C0.763258 1.72981 0.883537 1.66812 1.01333 1.6575C1.68 1.60333 2.34667 1.5625 3.01417 1.53417C3.02389 1.53388 3.03361 1.53388 3.04333 1.53417ZM6.545 3.89583C6.54917 3.89578 6.55333 3.89578 6.5575 3.89583C9.11695 3.92729 11.6705 4.15013 14.1967 4.5625C14.2604 4.57283 14.3215 4.59562 14.3765 4.62956C14.4314 4.66351 14.4791 4.70795 14.5169 4.76034C14.5546 4.81273 14.5817 4.87204 14.5965 4.9349C14.6114 4.99776 14.6137 5.06292 14.6033 5.12667C14.584 5.2445 14.5224 5.35127 14.4301 5.42702C14.3377 5.50278 14.221 5.54234 14.1017 5.53833C14.0805 5.53803 14.0593 5.53636 14.0383 5.53333C11.5609 5.12842 9.05673 4.90947 6.54667 4.87833C6.4821 4.87768 6.41829 4.86431 6.35889 4.839C6.29949 4.81369 6.24565 4.77692 6.20046 4.7308C6.15527 4.68468 6.11961 4.63011 6.09551 4.5702C6.0714 4.5103 6.05934 4.44623 6.06 4.38167C6.06151 4.25343 6.11307 4.13086 6.20367 4.04009C6.29428 3.94933 6.41676 3.89756 6.545 3.89583ZM3.03583 3.97667C3.1609 3.97708 3.28111 4.02514 3.37199 4.11107C3.46286 4.19699 3.51758 4.31432 3.525 4.43917C3.53229 4.56907 3.48779 4.69656 3.40126 4.79371C3.31472 4.89087 3.19321 4.94977 3.06333 4.9575C2.40833 4.99583 1.75333 5.04667 1.1 5.11083C1.08892 5.11204 1.0778 5.11288 1.06667 5.11333C0.942242 5.11665 0.821189 5.07266 0.72793 4.99023C0.634671 4.90779 0.576147 4.79306 0.564166 4.66917C0.551623 4.53944 0.591098 4.41005 0.673916 4.30941C0.756735 4.20878 0.876119 4.14515 1.00583 4.1325C1.6725 4.0675 2.33833 4.01583 3.00583 3.97667C3.01583 3.97636 3.02584 3.97636 3.03583 3.97667ZM6.5375 6.27917C6.54167 6.27911 6.54583 6.27911 6.55 6.27917C9.1 6.26833 11.6542 6.44917 14.1892 6.82083C14.2531 6.83021 14.3145 6.8521 14.37 6.88524C14.4255 6.91839 14.4738 6.96214 14.5124 7.01399C14.5509 7.06584 14.5789 7.12478 14.5946 7.18744C14.6104 7.2501 14.6136 7.31525 14.6042 7.37917C14.5868 7.49722 14.5271 7.60492 14.4361 7.6822C14.3452 7.75947 14.2293 7.80105 14.11 7.79917C14.0888 7.79887 14.0676 7.7972 14.0467 7.79417C11.5657 7.42974 9.06089 7.25201 6.55333 7.2625C6.48877 7.26272 6.42479 7.25022 6.36505 7.22571C6.30532 7.20121 6.25099 7.16517 6.20518 7.11967C6.15937 7.07417 6.12297 7.02009 6.09806 6.96053C6.07315 6.90096 6.06022 6.83707 6.06 6.7725C6.05951 6.64423 6.10917 6.52085 6.19838 6.42868C6.28759 6.33652 6.40928 6.28286 6.5375 6.27917ZM7.49833 8.65083C9.73312 8.64705 11.9657 8.79041 14.1817 9.08C14.3108 9.09682 14.428 9.16418 14.5075 9.26729C14.587 9.3704 14.6224 9.50084 14.6058 9.63C14.5904 9.74856 14.5324 9.85745 14.4425 9.93629C14.3526 10.0151 14.2371 10.0585 14.1175 10.0583C14.0963 10.0583 14.0752 10.0569 14.0542 10.0542C11.5707 9.73001 9.06647 9.59296 6.5625 9.64417C6.49793 9.64561 6.43371 9.63431 6.3735 9.61092C6.3133 9.58753 6.2583 9.55251 6.21163 9.50786C6.16497 9.4632 6.12756 9.40979 6.10154 9.35068C6.07552 9.29157 6.06141 9.2279 6.06 9.16333C6.05856 9.09869 6.06989 9.03441 6.09333 8.97415C6.11677 8.91389 6.15186 8.85885 6.1966 8.81218C6.24134 8.7655 6.29485 8.72811 6.35406 8.70214C6.41327 8.67617 6.47702 8.66213 6.54167 8.66083C6.86 8.65417 7.17917 8.65083 7.49833 8.65083ZM8.4475 11.0108C10.3608 11.0123 12.2724 11.1219 14.1733 11.3392C14.3028 11.3538 14.4212 11.4193 14.5024 11.5211C14.5837 11.623 14.6212 11.753 14.6067 11.8825C14.5931 12.0012 14.5369 12.1108 14.4484 12.191C14.3599 12.2712 14.2452 12.3165 14.1258 12.3183C14.1047 12.3186 14.0835 12.3175 14.0625 12.315C11.5757 12.0319 9.07115 11.936 6.57 12.0283C6.43986 12.0328 6.31325 11.9855 6.21795 11.8968C6.12265 11.808 6.06644 11.6851 6.06167 11.555C6.05694 11.4249 6.10403 11.2982 6.19261 11.2027C6.2812 11.1072 6.40403 11.0508 6.53417 11.0458C7.17167 11.0225 7.80917 11.0108 8.4475 11.0108Z"
          fill="black"
        />
      </svg>
    </SvgIcon>
  );
}

// function LogoutIcon() {
//   return (
//     <SvgIcon>
//       <svg
//         width="20"
//         height="23"
//         viewBox="0 0 20 23"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M18.603 11.3186L15.6695 15.8505M10.6816 11.3186H18.603H10.6816ZM18.603 11.3186L15.6695 6.78674L18.603 11.3186Z"
//           stroke="black"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//         <path
//           d="M11.5619 5.65376V3.58497C11.5618 3.27156 11.5113 2.96156 11.4135 2.67457C11.3157 2.38758 11.1726 2.12983 10.9935 1.91762C10.8143 1.70541 10.6029 1.54335 10.3726 1.44169C10.1423 1.34002 9.89807 1.30096 9.65544 1.32697L2.6142 2.08153C2.17417 2.1287 1.76398 2.38703 1.46499 2.80528C1.16599 3.22352 1.00002 3.77114 1 4.33952V18.2976C1.00002 18.866 1.16599 19.4137 1.46499 19.8319C1.76398 20.2501 2.17417 20.5085 2.6142 20.5556L9.65544 21.3113C9.89815 21.3374 10.1424 21.2983 10.3728 21.1965C10.6031 21.0948 10.8146 20.9326 10.9938 20.7203C11.173 20.508 11.316 20.2501 11.4138 19.963C11.5115 19.6758 11.562 19.3657 11.5619 19.0522V16.9834"
//           stroke="black"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//       </svg>
//     </SvgIcon>
//   );
// }

export default function Userdetails(props) {
  const history=useHistory()
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <div style={{zIndex:"10",position:"relative"}} >
    {/* <Card
      style={{
        background: "white",    
        height: "50px",
        width: "215px",
        borderRadius: "10px",
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "center",
        justifyContent: "flex-start",
        cursor: "pointer",
      }}
      onClick={handleToggle}
    >
      <Avatar
        sx={{
          width: 50,
          height: 45,
          borderRadius: "10px",
          margin: "0 3px 0 3px",
        }}
        variant="rounded"
        alt="Remy Sharp"
        src=""
      />

      <Typography
        style={{
          fontSize: "12px",
          fontWeight: "600",
          width: "256px",
          height: "25px",
          color: "#000000",
          fontStyle: "normlal",
          lineHeight: "18px",
          textAlign: "center",
        }}
      >
        Admin
      </Typography>

      <div
        onClick={handleToggle}
        style={{
          margin: "auto",
        }}
      > */}
        <IconButton onClick={handleToggle}>
          <MenuIcon
            ref={anchorRef}
            id="composition-button"
            aria-controls={open ? "composition-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-haspopup="true"
            fontSize="large"
            style={{
              color: "#00205c",
              // backgroundColor:"#00205c"
            }}
          />
        </IconButton>

        <div>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            placement="bottom-start"
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom-start" ? "left top" : "left bottom",
                }}
              >
                <Card
                  style={{
                    height: "100px",
                    width: "128px",
                    left: "50px",
                    top: "8px",
                    borderRadius: "10px",
                    backgroundColor: " #FFFFFF",
                    justifyContent: "center",

                    cursor: "pointer",
                  }}
                >
                  <ClickAwayListener onClickAway={handleClose}>
                    <nav aria-label="main mailbox folders">
                      <List
                        autofocusitem={open}
                        id="composition-menu"
                        aria-labelledby="composition-button"
                        onKeyDown={handleListKeyDown}
                       
                      >
                        <ListItem disablePadding>
                          {/* <Link
                            to="/Loggeer"
                            style={{
                              textDecoration: "none",
                              color: "black",
                              fontFamily: "Arial",
                            }}
                          > */}
                            <ListItemButton
                          onClick={()=>history.push(`/Loggeer/${sessionStorage.getItem("metadata")}`)}
                                                        >
                      <ListItemIcon>    
                                <Logger />
                              </ListItemIcon>
                              <ListItemText
                                style={{
                                  marginLeft: "-15px",
                                  fontFamily: "Arial",
                                }}
                                primary="Logger"
                              />
                            </ListItemButton>
                          {/* </Link> */}
                        </ListItem>
                        <Divider />

                        <ListItem disablePadding>
                          {/* <Link
                            to="/apid"
                            style={{
                              textDecoration: "none",
                              color: "black",
                              fontFamily: "Arial",
                            }}
                          > */}
                            <ListItemButton
                            onClick={()=>history.push(`/apid/${sessionStorage.getItem("metadata")}`)}
                            >
                              <ListItemIcon>
                                <Apidoc />
                              </ListItemIcon>
                              <ListItemText
                                style={{ marginLeft: "-15px" }}
                                primary="Apidoc"
                              />
                            </ListItemButton>
                          {/* </Link> */}
                        </ListItem>
                        <Divider />
                        <ListItem disablePadding>
                          {/* <Link
                            to="/"
                            style={{
                              textDecoration: "none",
                              color: "black",
                              fontFamily: "Arial",
                            }}
                          >
                            <ListItemButton onClick={handleClose}>
                              <ListItemIcon>
                                <LogoutIcon />
                              </ListItemIcon>
                              <ListItemText
                                style={{
                                  marginLeft: "-15px",
                                  fontFamily: "Arial",
                                }}
                                primary="Logout"
                              />
                            </ListItemButton>
                          </Link> */}
                        </ListItem>
                        <Divider />
                      </List>
                    </nav>
                  </ClickAwayListener>
                </Card>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
    // </Card>
    // </div>
  );
}
